export { default as SelectLifestylesContentSidebar } from './SelectLifestylesContentSidebar';
